import React, { useEffect, useState } from 'react';

const KakaoMap = () => {
  const [mapHeight, setMapHeight] = useState('670px');

  useEffect(() => {
    // ✅ 모바일 디바이스 높이 조정
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    setMapHeight(isMobile ? '440px' : '670px');

    const { kakao } = window || {};
    if (!kakao || !kakao.maps) return;

    const container = document.getElementById('map-bon');
    if (!container) return;

    const centerPosition = new kakao.maps.LatLng(37.002591953575376, 126.58530535848365);

    const map = new kakao.maps.Map(container, {
      center: centerPosition,
      level: 2,
    });

    const markerImage = new kakao.maps.MarkerImage('/kakao_icon.png', new kakao.maps.Size(70, 70), {
      offset: new kakao.maps.Point(37, 73),
    });

    const marker = new kakao.maps.Marker({
      position: centerPosition,
      image: markerImage,
    });

    marker.setMap(map);
  }, []);

  return (
    <div>
      <div
        id="map-bon"
        className="map"
        style={{
          width: '100%',
          height: mapHeight,
        }}
      />
    </div>
  );
};

export default KakaoMap;
